import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import Divider from "@material-ui/core/Divider";
import Button from "@material-ui/core/Button";
import CircularProgress from "@material-ui/core/CircularProgress";
import Grid from "@material-ui/core/Grid";

import Axios from "axios";

import { useStyles } from "./AddDriver.css";
import AdminHeader from "../../../../../Components/NavBar/Admin/AdminHeader/AdminHeader";
import { CustomLinearProgress } from "../../../../../Components/CustomLinearProgress/CustomLinearProgress";
import { url } from "../../../../../Config/Config";
import { withRouter } from "react-router";
import { connect } from "react-redux";
import { publicImageUrl } from "../../../../../Config/publicImageUrl";
import { getAdminRefreshToken } from "../../../../../Redux/Actions/actions";
import FormLoader from "../../../../../Components/FormLoader/FormLoader";
import PageTitle from "../../../../../Components/PageTitle/PageTitle";
import CustomBreadCrumbs from "../../../../../Components/CustomBreadCrumbs/CustomBreadCrumbs";

class AddDriver extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: {
        driverFullName: "",
        mobileNumber: "",
        altMobileNumber: "",
        address: "",
        category: "",
        image: "",
        citizenshipFront: "",
        citizenshipBack: "",
        drivingLicenseFront: "",
        drivingLicenseBack: "",
      },
      files: {
        personalPhotoFiles: [],
        citizenshipFrontFiles: [],
        citizenshipBackFiles: [],
        licenseFrontFiles: [],
        licenseBackFiles: [],
      },
      url: {
        personalPhotoUrl: "",
        citizenshipFrontUrl: "",
        citizenshipBackUrl: "",
        licenseFrontUrl: "",
        licenseBackUrl: "",
      },
      loading: {
        personalPhotoLoading: false,
        citizenshipFrontLoading: false,
        citizenshipBackLoading: false,
        licenseFrontLoading: false,
        licenseBackLoading: false,
      },
      percentage: {
        personalPhotoPercentage: 0,
        citizenshipFrontPercentage: 0,
        citizenshipBackPercentage: 0,
        licenseFrontPercentage: 0,
        licenseBackPercentage: 0,
      },
      error: {
        personalPhotoError: "",
        citizenshipFrontError: "",
        citizenshipBackError: "",
        licenseFrontError: "",
        licenseBackError: "",
      },
      deleteStatus: {
        personalPhotoDeleteStatus: false,
        citizenshipFrontDeleteStatus: false,
        citizenshipBackDeleteStatus: false,
        licenseFrontDeleteStatus: false,
        licenseBackDeleteStatus: false,
      },
      deleteImage: {
        personalPhotoDelete: "",
        citizenshipFrontDelete: "",
        citizenshipBackDelete: "",
        licenseFrontDelete: "",
        licenseBackDelete: "",
      },
      formLoading: false,
    };
  }

  componentDidMount() {
    if (this.props.driverId) {
      this.getDriverDetails(this.props.driverId);
    }
  }

  getDriverDetails = async (driverId) => {
    try {
      const response = await Axios.get(`${url}/api/drivers/${driverId}`, {
        headers: {
          Authorization: `Bearer ${this.props.adminToken}`,
        },
      });
      if (response.data.driver) {
        this.setState({
          data: {
            driverFullName: response.data.driver.driverFullName,
            mobileNumber: response.data.driver.mobileNumber,
            altMobileNumber: response.data.driver.altMobileNumber
              ? response.data.driver.altMobileNumber
              : "",
            address: response.data.driver.address,
            category: response.data.driver.category,
            image: response.data.driver.image,
            citizenshipFront: response.data.driver.citizenshipFront,
            citizenshipBack: response.data.driver.citizenshipBack,
            drivingLicenseFront: response.data.driver.drivingLicenseFront,
            drivingLicenseBack: response.data.driver.drivingLicenseBack,
          },
          deleteImage: {
            personalPhotoDelete: response.data.driver.image,
            citizenshipFrontDelete: response.data.driver.citizenshipFront,
            citizenshipBackDelete: response.data.driver.citizenshipBack,
            licenseFrontDelete: response.data.driver.drivingLicenseFront,
            licenseBackDelete: response.data.driver.drivingLicenseBack,
          },
        });
      }
    } catch (error) {
      if (
        error.response.data === "jwt expired" &&
        error.response.status === 401
      ) {
        console.clear();
        let refreshToken = { refreshToken: this.props.refreshToken };
        this.props.getAdminRefreshToken(refreshToken, this.props.role);
        this.getDriverDetails(driverId);
      }
    }
  };

  handleChange = (e) => {
    this.setState({
      data: {
        ...this.state.data,
        [e.target.name]: e.target.value,
      },
    });
  };

  handlePersonPhoto = async (e) => {
    let reader = new FileReader();
    let files = e.target.files[0];
    this.setState({
      files: { ...this.state.files, personalPhotoFiles: files },
      loading: {
        ...this.state.loading,
        personalPhotoLoading: true,
      },
    });

    if (this.props.driverId) {
      this.setState({
        deleteStatus: {
          ...this.state.deleteStatus,
          personalPhotoDeleteStatus: true,
        },
      });
    }

    reader.onload = () => {
      this.setState({
        url: {
          ...this.state.url,
          personalPhotoUrl: window.URL.createObjectURL(e.target.files[0]),
        },
      });
    };

    reader.onprogress = (data) => {
      this.setState({
        loading: {
          ...this.state.loading,
          personalPhotoLoading: false,
        },
      });
      if (data.lengthComputable) {
        var progress = parseInt((data.loaded / data.total) * 100, 10);
        this.setState({
          percentage: {
            ...this.state.percentage,
            personalPhotoPercentage: progress,
          },
        });
      }
    };

    if (files) {
      reader.readAsDataURL(files);
    }
  };

  handlePersonPhotoProgress = () =>
    this.state.percentage.personalPhotoPercentage ? (
      <>
        <CustomLinearProgress
          value={this.state.percentage.personalPhotoPercentage}
          variant="determinate"
        />
        {this.state.percentage.personalPhotoPercentage === 100 ? (
          <>Upload Complete</>
        ) : (
          <>{this.state.percentage.personalPhotoPercentage}%</>
        )}
      </>
    ) : null;

  handleCitizenshipFront = async (e) => {
    let reader = new FileReader();
    let files = e.target.files[0];
    this.setState({
      files: { ...this.state.files, citizenshipFrontFiles: files },
      loading: {
        ...this.state.loading,
        citizenshipFrontLoading: true,
      },
    });

    if (this.props.driverId) {
      this.setState({
        deleteStatus: {
          ...this.state.deleteStatus,
          citizenshipFrontDeleteStatus: true,
        },
      });
    }

    reader.onload = () => {
      this.setState({
        url: {
          ...this.state.url,
          citizenshipFrontUrl: window.URL.createObjectURL(e.target.files[0]),
        },
      });
    };

    reader.onprogress = (data) => {
      this.setState({
        loading: {
          ...this.state.loading,
          citizenshipFrontLoading: false,
        },
      });
      if (data.lengthComputable) {
        var progress = parseInt((data.loaded / data.total) * 100, 10);
        this.setState({
          percentage: {
            ...this.state.percentage,
            citizenshipFrontPercentage: progress,
          },
        });
      }
    };

    if (files) {
      reader.readAsDataURL(files);
    }
  };

  handleCitizenshipFrontProgress = () =>
    this.state.percentage.citizenshipFrontPercentage ? (
      <>
        <CustomLinearProgress
          value={this.state.percentage.citizenshipFrontPercentage}
          variant="determinate"
        />
        {this.state.percentage.citizenshipFrontPercentage === 100 ? (
          <>Upload Complete</>
        ) : (
          <>{this.state.percentage.citizenshipFrontPercentage}%</>
        )}
      </>
    ) : null;

  handleCitizenshipBack = async (e) => {
    let reader = new FileReader();
    let files = e.target.files[0];
    this.setState({
      files: { ...this.state.files, citizenshipBackFiles: files },
      loading: {
        ...this.state.loading,
        citizenshipBackLoading: true,
      },
    });

    if (this.props.driverId) {
      this.setState({
        deleteStatus: {
          ...this.state.deleteStatus,
          citizenshipBackDeleteStatus: true,
        },
      });
    }

    reader.onload = () => {
      this.setState({
        url: {
          ...this.state.url,
          citizenshipBackUrl: window.URL.createObjectURL(e.target.files[0]),
        },
      });
    };

    reader.onprogress = (data) => {
      this.setState({
        loading: {
          ...this.state.loading,
          citizenshipBackLoading: false,
        },
      });
      if (data.lengthComputable) {
        var progress = parseInt((data.loaded / data.total) * 100, 10);
        this.setState({
          percentage: {
            ...this.state.percentage,
            citizenshipBackPercentage: progress,
          },
        });
      }
    };

    if (files) {
      reader.readAsDataURL(files);
    }
  };

  handleCitizenshipBackProgress = () =>
    this.state.percentage.citizenshipBackPercentage ? (
      <>
        <CustomLinearProgress
          value={this.state.percentage.citizenshipBackPercentage}
          variant="determinate"
        />
        {this.state.percentage.citizenshipBackPercentage === 100 ? (
          <>Upload Complete</>
        ) : (
          <>{this.state.percentage.citizenshipBackPercentage}%</>
        )}
      </>
    ) : null;

  handleLicenseBack = async (e) => {
    let reader = new FileReader();
    let files = e.target.files[0];
    this.setState({
      files: { ...this.state.files, licenseBackFiles: files },
      loading: {
        ...this.state.loading,
        licenseBackLoading: true,
      },
    });

    if (this.props.driverId) {
      this.setState({
        deleteStatus: {
          ...this.state.deleteStatus,
          licenseFrontDeleteStatus: true,
        },
      });
    }

    reader.onload = () => {
      this.setState({
        url: {
          ...this.state.url,
          licenseBackUrl: window.URL.createObjectURL(e.target.files[0]),
        },
      });
    };

    reader.onprogress = (data) => {
      this.setState({
        loading: {
          ...this.state.loading,
          licenseBackLoading: false,
        },
      });
      if (data.lengthComputable) {
        var progress = parseInt((data.loaded / data.total) * 100, 10);
        this.setState({
          percentage: {
            ...this.state.percentage,
            licenseBackPercentage: progress,
          },
        });
      }
    };

    if (files) {
      reader.readAsDataURL(files);
    }
  };

  handleLicenseFrontProgress = () =>
    this.state.percentage.licenseFrontPercentage ? (
      <>
        <CustomLinearProgress
          value={this.state.percentage.licenseFrontPercentage}
          variant="determinate"
        />
        {this.state.percentage.licenseFrontPercentage === 100 ? (
          <>Upload Complete</>
        ) : (
          <>{this.state.percentage.licenseFrontPercentage}%</>
        )}
      </>
    ) : null;

  handleLicenseFront = async (e) => {
    let reader = new FileReader();
    let files = e.target.files[0];
    this.setState({
      files: { ...this.state.files, licenseFrontFiles: files },
      loading: {
        ...this.state.loading,
        licenseFrontLoading: true,
      },
    });

    if (this.props.driverId) {
      this.setState({
        deleteStatus: {
          ...this.state.deleteStatus,
          licenseBackDeleteStatus: true,
        },
      });
    }

    reader.onload = () => {
      this.setState({
        url: {
          ...this.state.url,
          licenseFrontUrl: window.URL.createObjectURL(e.target.files[0]),
        },
      });
    };

    reader.onprogress = (data) => {
      this.setState({
        loading: {
          ...this.state.loading,
          licenseFrontLoading: false,
        },
      });
      if (data.lengthComputable) {
        var progress = parseInt((data.loaded / data.total) * 100, 10);
        this.setState({
          percentage: {
            ...this.state.percentage,
            licenseFrontPercentage: progress,
          },
        });
      }
    };

    if (files) {
      reader.readAsDataURL(files);
    }
  };

  handleLicenseBackProgress = () =>
    this.state.percentage.licenseBackPercentage ? (
      <>
        <CustomLinearProgress
          value={this.state.percentage.licenseBackPercentage}
          variant="determinate"
        />
        {this.state.percentage.licenseBackPercentage === 100 ? (
          <>Upload Complete</>
        ) : (
          <>{this.state.percentage.licenseBackPercentage}%</>
        )}
      </>
    ) : null;

  uploadImage = async (dirName, files) => {
    const {
      data: { signedUrl, key },
    } = await Axios.post(`${url}/api/uploads`, {
      dir: dirName,
      contentType: files.type,
    });
    await Axios.put(signedUrl, files, {
      headers: {
        "content-type": files.type,
      },
    });
    await Axios.post(`${url}/api/uploads/public`, {
      fileName: key,
    });

    return key;
  };

  filterData = (data) => {
    let changedData = data;
    if (data.altMobileNumber === "") {
      delete changedData.altMobileNumber;
    }
    return changedData;
  };

  handleSubmit = async (e) => {
    e.preventDefault();
    try {
      this.setState({ formLoading: true });
      if (this.props.driverId) {
        this.handleUpdate(e);
      } else {
        let data = this.filterData(this.state.data);
        let personalPhoto = await this.uploadImage(
          "DriverImage",
          this.state.files.personalPhotoFiles
        );
        data = { ...data, image: personalPhoto };

        let citizenshipFront = await this.uploadImage(
          "Citizenship",
          this.state.files.citizenshipFrontFiles
        );
        data = { ...data, citizenshipFront: citizenshipFront };

        let citizenshipBack = await this.uploadImage(
          "Citizenship",
          this.state.files.citizenshipBackFiles
        );
        data = { ...data, citizenshipBack: citizenshipBack };

        let licenseFront = await this.uploadImage(
          "License",
          this.state.files.licenseFrontFiles
        );
        data = { ...data, drivingLicenseFront: licenseFront };

        let licenseBack = await this.uploadImage(
          "License",
          this.state.files.licenseBackFiles
        );

        data = { ...data, drivingLicenseBack: licenseBack };
        const response = await Axios.post(`${url}/api/drivers`, data, {
          headers: {
            Authorization: `Bearer ${this.props.adminToken}`,
          },
        });
        if (response.data.message === "Driver created successfully") {
          this.props.history.push(`/administration/driver`);
        }
      }
    } catch (error) {
      this.setState({ formLoading: false });
      if (
        error.response.data === "jwt expired" &&
        error.response.status === 401
      ) {
        console.clear();
        let refreshToken = { refreshToken: this.props.refreshToken };
        this.props.getAdminRefreshToken(refreshToken, this.props.role);
        this.handleSubmit(e);
      }
    }
  };

  handleUpdate = async (e) => {
    e.preventDefault();
    let data = this.filterData(this.state.data);
    if (this.state.deleteStatus.personalPhotoDeleteStatus) {
      let personalPhoto = await this.uploadImage(
        "DriverImage",
        this.state.files.personalPhotoFiles
      );
      data = { ...data, image: personalPhoto };
      this.deleteImage(this.state.deleteImage.personalPhotoDelete);
    }

    if (this.state.deleteStatus.citizenshipFrontDeleteStatus) {
      let citizenshipFront = await this.uploadImage(
        "Citizenship",
        this.state.files.citizenshipFrontFiles
      );
      data = { ...data, citizenshipFront: citizenshipFront };
      this.deleteImage(this.state.deleteImage.citizenshipFrontDelete);
    }

    if (this.state.deleteStatus.citizenshipBackDeleteStatus) {
      let citizenshipBack = await this.uploadImage(
        "Citizenship",
        this.state.files.citizenshipBackFiles
      );
      data = { ...data, citizenshipBack: citizenshipBack };
      this.deleteImage(this.state.deleteImage.citizenshipBackDelete);
    }

    if (this.state.deleteStatus.licenseFrontDeleteStatus) {
      let licenseFront = await this.uploadImage(
        "License",
        this.state.files.licenseFrontFiles
      );
      data = { ...data, drivingLicenseFront: licenseFront };
      this.deleteImage(this.state.deleteImage.licenseFrontDelete);
    }
    if (this.state.deleteStatus.licenseBackDeleteStatus) {
      let licenseBack = await this.uploadImage(
        "License",
        this.state.files.licenseBackFiles
      );

      data = { ...data, drivingLicenseBack: licenseBack };
      this.deleteImage(this.state.deleteImage.licenseBackDelete);
    }
    const response = await Axios.put(
      `${url}/api/drivers/${this.props.driverId}`,
      data,
      {
        headers: {
          Authorization: `Bearer ${this.props.adminToken}`,
        },
      }
    );
    if (response.data.message === "Driver details updated successfully") {
      this.props.history.push(`/administration/driver`);
    }
  };

  deleteImage = async (imageToDelete) => {
    await Axios.post(
      `${url}/api/uploads/delete/`,
      {
        fileName: imageToDelete,
      },
      {
        headers: {
          Authorization: `Bearer ${this.props.adminToken}`,
        },
      }
    );
  };

  render() {
    const { classes } = this.props;
    return (
      <div className={classes.root}>
        <AdminHeader />
        <div className={classes.content}>
          <div className={classes.toolbar} />

          <CustomBreadCrumbs url={this.props.match.url} />
          {this.props.driverId ? (
            <PageTitle title="Edit Deriver List" />
          ) : (
            <PageTitle title="Add New Driver" />
          )}

          <form onSubmit={this.handleSubmit}>
            <div>
              <div style={{ fontSize: 18, fontWeight: "bold" }}>
                General Information
              </div>
              <Divider />
              <TextField
                name="driverFullName"
                type="text"
                required
                fullWidth
                label="Full Name"
                variant="outlined"
                margin="normal"
                placeholder="Enter driver's full name"
                className={classes.inputWithMargin}
                InputProps={{
                  classes: {
                    notchedOutline: classes.notchedOutline,
                    focused: classes.focused,
                  },
                }}
                InputLabelProps={{
                  classes: {
                    root: classes.labelRoot,
                    focused: classes.labelFocused,
                  },
                  shrink: true,
                }}
                value={this.state.data.driverFullName}
                onChange={this.handleChange}
              />
              <TextField
                name="address"
                type="address"
                required
                fullWidth
                label="Address"
                variant="outlined"
                margin="normal"
                placeholder="Enter driver's address"
                className={classes.inputWithMargin}
                InputProps={{
                  classes: {
                    notchedOutline: classes.notchedOutline,
                    focused: classes.focused,
                  },
                }}
                InputLabelProps={{
                  classes: {
                    root: classes.labelRoot,
                    focused: classes.labelFocused,
                  },
                  shrink: true,
                }}
                value={this.state.data.address}
                onChange={this.handleChange}
              />

              <TextField
                name="mobileNumber"
                type="tel"
                required
                fullWidth
                label="Mobile Number"
                variant="outlined"
                margin="normal"
                placeholder="Enter driver's mobile number"
                className={classes.inputWithMargin}
                InputProps={{
                  classes: {
                    notchedOutline: classes.notchedOutline,
                    focused: classes.focused,
                  },
                }}
                InputLabelProps={{
                  classes: {
                    root: classes.labelRoot,
                    focused: classes.labelFocused,
                  },
                  shrink: true,
                }}
                value={this.state.data.mobileNumber}
                onChange={this.handleChange}
              />
              <TextField
                name="altMobileNumber"
                type="tel"
                fullWidth
                label="Alternate Mobile Number(Optional)"
                variant="outlined"
                margin="normal"
                placeholder="Enter driver's alternate mobile number"
                className={classes.inputWithMargin}
                InputProps={{
                  classes: {
                    notchedOutline: classes.notchedOutline,
                    focused: classes.focused,
                  },
                }}
                InputLabelProps={{
                  classes: {
                    root: classes.labelRoot,
                    focused: classes.labelFocused,
                  },
                  shrink: true,
                }}
                value={this.state.data.altMobileNumber}
                onChange={this.handleChange}
              />

              <TextField
                name="category"
                select
                required
                fullWidth
                label="Category"
                variant="outlined"
                margin="normal"
                placeholder="vechicle year made time"
                className={classes.inputWithMargin}
                SelectProps={{ native: true }}
                InputProps={{
                  classes: {
                    notchedOutline: classes.notchedOutline,
                    focused: classes.focused,
                  },
                }}
                InputLabelProps={{
                  classes: {
                    root: classes.labelRoot,
                    focused: classes.labelFocused,
                  },
                  shrink: true,
                }}
                value={this.state.data.category}
                onChange={this.handleChange}
              >
                <option value="">Select Any One</option>
                <option value="Driver">Driver</option>
                <option value="Assistant Driver">Assistant Driver</option>
              </TextField>
            </div>

            <div>
              <div style={{ fontSize: 18, fontWeight: "bold" }}>Images</div>
              <Divider />
              <Grid container spacing={3}>
                <Grid
                  item
                  xs={12}
                  sm={12}
                  md={12}
                  xl={12}
                  lg={12}
                  className={classes.imagePart}
                >
                  <div
                    style={{
                      textAlign: "center",
                      fontWeight: "bold",
                    }}
                  >
                    Driver's Photo
                  </div>
                  {this.state.url.personalPhotoUrl ? (
                    <img
                      src={this.state.url.personalPhotoUrl}
                      alt={this.state.data.name}
                      style={{ width: 100, height: 100 }}
                    />
                  ) : (
                    this.state.data.image && (
                      <img
                        src={`${publicImageUrl}/${this.state.data.image}`}
                        alt={this.state.data.driverFullName}
                        style={{ width: 100, height: 100 }}
                      />
                    )
                  )}
                  <input
                    type="file"
                    accept="image/*"
                    onChange={this.handlePersonPhoto}
                  />
                  <div>
                    <div style={{ padding: 10 }}>
                      {this.handlePersonPhotoProgress()}
                    </div>
                    <div>
                      {this.state.loading.personalPhotoLoading === true && (
                        <CircularProgress />
                      )}
                    </div>
                  </div>
                  <div style={{ color: "red", fontWeight: "bold" }}>
                    {this.state.error.personalPhotoError}
                  </div>
                </Grid>

                <Grid
                  item
                  xs={12}
                  sm={12}
                  md={6}
                  xl={6}
                  lg={6}
                  className={classes.imagePart}
                >
                  <div style={{ textAlign: "left", fontWeight: "bold" }}>
                    Citizenship Front
                  </div>
                  {this.state.url.citizenshipFrontUrl ? (
                    <img
                      src={this.state.url.citizenshipFrontUrl}
                      alt={this.state.data.name}
                      style={{ width: 100, height: 100 }}
                    />
                  ) : (
                    this.state.data.citizenshipFront && (
                      <img
                        src={`${publicImageUrl}/${this.state.data.citizenshipFront}`}
                        alt={this.state.data.driverFullName}
                        style={{ width: 100, height: 100 }}
                      />
                    )
                  )}
                  <input
                    type="file"
                    accept="image/*"
                    onChange={this.handleCitizenshipFront}
                  />
                  <div>
                    <div style={{ padding: 10 }}>
                      {this.handleCitizenshipFrontProgress()}
                    </div>
                    <div>
                      {this.state.loading.citizenshipFrontLoading === true && (
                        <CircularProgress />
                      )}
                    </div>
                  </div>
                  <div style={{ color: "red", fontWeight: "bold" }}>
                    {this.state.error.citizenshipFrontError}
                  </div>
                </Grid>

                <Grid
                  item
                  xs={12}
                  sm={12}
                  md={6}
                  xl={6}
                  lg={6}
                  className={classes.imagePart}
                >
                  <div style={{ textAlign: "left", fontWeight: "bold" }}>
                    Citizenship Back
                  </div>
                  {this.state.url.citizenshipBackUrl ? (
                    <img
                      src={this.state.url.citizenshipBackUrl}
                      alt={this.state.data.name}
                      style={{ width: 100, height: 100 }}
                    />
                  ) : (
                    this.state.data.citizenshipBack && (
                      <img
                        src={`${publicImageUrl}/${this.state.data.citizenshipBack}`}
                        alt={this.state.data.driverFullName}
                        style={{ width: 100, height: 100 }}
                      />
                    )
                  )}
                  <input
                    type="file"
                    accept="image/*"
                    onChange={this.handleCitizenshipBack}
                  />
                  <div>
                    <div style={{ padding: 10 }}>
                      {this.handleCitizenshipBackProgress()}
                    </div>
                    <div>
                      {this.state.loading.citizenshipBackLoading === true && (
                        <CircularProgress />
                      )}
                    </div>
                  </div>
                  <div style={{ color: "red", fontWeight: "bold" }}>
                    {this.state.error.citizenshipBackError}
                  </div>
                </Grid>
                <Grid
                  item
                  xs={12}
                  sm={12}
                  md={6}
                  xl={6}
                  lg={6}
                  className={classes.imagePart}
                >
                  <div style={{ textAlign: "left", fontWeight: "bold" }}>
                    License Front
                  </div>
                  {this.state.url.licenseFrontUrl ? (
                    <img
                      src={this.state.url.licenseFrontUrl}
                      alt={this.state.data.name}
                      style={{ width: 100, height: 100 }}
                    />
                  ) : (
                    this.state.data.drivingLicenseFront && (
                      <img
                        src={`${publicImageUrl}/${this.state.data.drivingLicenseFront}`}
                        alt={this.state.data.driverFullName}
                        style={{ width: 100, height: 100 }}
                      />
                    )
                  )}
                  <input
                    type="file"
                    accept="image/*"
                    onChange={this.handleLicenseFront}
                  />
                  <div>
                    <div style={{ padding: 10 }}>
                      {this.handleLicenseFrontProgress()}
                    </div>
                    <div>
                      {this.state.loading.licenseFrontLoading === true && (
                        <CircularProgress />
                      )}
                    </div>
                  </div>
                  <div style={{ color: "red", fontWeight: "bold" }}>
                    {this.state.error.licenseFrontError}
                  </div>
                </Grid>
                <Grid
                  item
                  xs={12}
                  sm={12}
                  md={6}
                  xl={6}
                  lg={6}
                  className={classes.imagePart}
                >
                  <div style={{ textAlign: "left", fontWeight: "bold" }}>
                    License Back
                  </div>
                  {this.state.url.licenseBackUrl ? (
                    <img
                      src={this.state.url.licenseBackUrl}
                      alt={this.state.data.name}
                      style={{ width: 100, height: 100 }}
                    />
                  ) : (
                    this.state.data.drivingLicenseBack && (
                      <img
                        src={`${publicImageUrl}/${this.state.data.drivingLicenseBack}`}
                        alt={this.state.data.driverFullName}
                        style={{ width: 100, height: 100 }}
                      />
                    )
                  )}
                  <input
                    type="file"
                    accept="image/*"
                    onChange={this.handleLicenseBack}
                  />
                  <div>
                    <div style={{ padding: 10 }}>
                      {this.handleLicenseBackProgress()}
                    </div>
                    <div>
                      {this.state.loading.licenseBackLoading === true && (
                        <CircularProgress />
                      )}
                    </div>
                  </div>
                  <div style={{ color: "red", fontWeight: "bold" }}>
                    {this.state.error.licenseBackError}
                  </div>
                </Grid>
              </Grid>
            </div>
            <br />
            <div style={{ display: "flex", alignItems: "center" }}>
              <Button
                type="submit"
                variant="outlined"
                color="primary"
                className={classes.buttonStyle}
              >
                {this.props.driverId ? "Update" : "Submit"}
              </Button>

              {this.state.formLoading && <FormLoader />}
            </div>
          </form>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    adminToken: state.AdminReducer.adminToken,
    refreshToken: state.AdminReducer.refreshToken,
    role: state.AdminReducer.role,
    isAdmin: state.AdminReducer.isAdmin,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getAdminRefreshToken: (refreshToken, role) => {
      dispatch(getAdminRefreshToken(refreshToken, role));
    },
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(useStyles)(withRouter(AddDriver)));
